import React from 'react';
import { useContext } from 'react';
import MaterialContext from '../context/material/materialContext';

const SupplierSiteList = () => {
  const materialContext = useContext(MaterialContext);
  const { supplierSites, setSupplierSite } = materialContext;

  return (
    <div className="list" style={listStyle}>
      {supplierSites.map(site => (
        <div className="list-item" key={site.id} onClick={() => setSupplierSite(site)}>
          {site.name}
        </div>
      ))}
    </div>
  );
};

const listStyle = {
  backGroundColor: 'rgb(239, 239, 239), rgb(59, 59, 59)',
};

export default SupplierSiteList;
